import type { Slice } from '@reduxjs/toolkit';

const createStatusCounts = (
  reduxActions: Slice['actions']
): Record<string, number> =>
  Object.fromEntries(
    Object.entries(reduxActions)
      .filter(
        ([actionName]) =>
          actionName.indexOf('SUCCESS') >= 0 ||
          actionName.indexOf('FAILURE') >= 0
      )
      .map(([_actionName, action]) => [action.type, 0])
  );

export type StatusCounts = ReturnType<typeof createStatusCounts>;

export default createStatusCounts;
